import "./user_management.scss";
import Swal from "sweetalert2";
import { showSwalSuccess, showSwalError } from "../../utils/swal";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import { showSwalQuestion } from "../../utils/swal";
import Helmet from "react-helmet";
import useAxios from "../../services/useAxios.tsx";

import Modals from "./Modals";
import React, { useEffect, useState, useContext } from "react";

import Filter from "./Filter";
import PersonnelTab from "./PersonnelTab";
import CustomerTab from "./CustomerTab";
import WithAuthentication from "../../Authentication/AuthenticationContext";
import Loader from "../../utils/Loader";
import { isString } from "lodash";
import { numberToWords } from "@persian-tools/persian-tools";
export default function UserManagement() {
  const { execute: Delete_users } = useAxios("test/Delete_users");
  const { execute: Update_Users } = useAxios("test/Update_Users");
  const { execute: files } = useAxios("test/files");
  const { execute: Find_UserRoll } = useAxios("test/Find_UserRoll");
  const { execute: Find_Tag } = useAxios("test/Find_Tag");
  const { execute: Find_ProductServices } = useAxios(
    "test/Find_ProductServices"
  );
  const { execute: Find_Customers } = useAxios("test/Find_Customers");
  const { execute: fullusers } = useAxios("test/fullusers");
  const { execute: access_level } = useAxios("test/access_level");
  const { execute: Insert_Message } = useAxios("api/Insert_Message");
  const [loading, setLoading] = useState(true);
  const [UpdaterModal, setUpdaterModal] = useState(true);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [filteredPersonel, setFilteredPersonel] = useState([]);
  const [chosenCustomers, setChosenCustomers] = useState([]);
  const [chosenPersonel, setChosenPersonel] = useState([]);
  const [countCustomers, setCountCustomers] = useState("");
  const [countPersonal, setCountPersonal] = useState("");
  const [tags, settags] = useState([]);
  const [PServices, setPServices] = useState([]);
  const [Customers, setCustomers] = useState([]);
  const [Access, setAccess] = useState([]);
  const [Tab, setTab] = useState(1);
  const [Citys, setCitys] = useState([]);
  const [UserAccess, setUserAccess] = useState([]);
  const [FirstAccess, setFirstAccess] = useState([]);
  const [FilterKey, setFilterKey] = useState(false);
  const [id, setId] = useState("");
  const [dates, setDates] = useState([]);
  const [filter, setFilter] = useState({
    user_type: "",
    fname: "",
    lname: "",
    mobile: "",
    codemeli: "",
    frommtm: "",
    tomtm: "",
    main_status: "",
    user_tags_ids: "",
  });
  const [filterTag, setFilterTag] = useState([]);
  const { userInfo } = useContext(WithAuthentication);

  const [Updater, setUpdater] = useState(false);
  const [SelectedUserInformation, setSelectedUserInformation] = useState({});
  const auth = useContext(WithAuthentication);
  const [pagination, setpagination] = useState(0);
  const [pagination2, setpagination2] = useState(0);

  //TODO use context for authentication
  // const auth = { userInfo: { id: 1 } };

  function deleteUser(id) {
    showSwalQuestion("آیا از حذف کاربر مطمئن هستید؟").then((result) => {
      if (result.isConfirmed) {
        let form = new FormData();
        form.append("conditions", `id/=/${id}`);
        Delete_users(form)
          .then((data) => {
            if (!(data.status == 1)) {
              Swal.fire("مشکلی در حذف کاربر پیش آمده است", "", "warning");
            }
            if (data.status == 1) {
              showSwalSuccess(" حذف کاربر با موفقیت انجام شد");
              setUpdater(!Updater);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  function changeStatus(id, nextStatus) {
    if (id.length == 1) {
      let text =
        nextStatus == 2
          ? "آیا از مسدود کردن کاربر مطمئن هستید؟"
          : "آیا از فعال کردن کاربر مطمئن هستید؟";
      showSwalQuestion(text).then((result) => {
        if (result.isConfirmed) {
          let form = new FormData();
          form.append("keyvalues", `main_status,${nextStatus}`);
          form.append("conditions", `id/=/${id[0]}`);
          Update_Users(form)
            .then((data) => {
              if (!(data.status == 1)) {
                Swal.fire(
                  "مشکلی در تغییر وضعیت کاربر پیش آمده است",
                  "",
                  "warning"
                );
              }
              if (data.status == 1) {
                setUpdater(!Updater);
                showSwalSuccess("تغییر وضعیت کاربر با موفقیت انجام شد");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    } else {
      let breaK = true;
      let text =
        nextStatus == 2
          ? "آیا از مسدود کردن کاربران مطمئن هستید؟"
          : "آیا از فعال کردن کاربران مطمئن هستید؟";

      showSwalQuestion(text).then((result) => {
        if (result.isConfirmed) {
          let wrong = true;
          id.map((item) => {
            let form = new FormData();
            form.append("keyvalues", `main_status,${nextStatus}`);
            form.append("conditions", `id/=/${item[0]}`);
            Update_Users(form)
              .then((data) => {
                if (data.status != 1 && wrong) {
                  wrong = false;
                  Swal.fire(
                    "مشکلی در تغییر وضعیت تعدادی از کاربران پیش آمده است",
                    "",
                    "warning"
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              });
          });
          if (wrong) {
            showSwalSuccess("تغییر وضعیت کاربران با موفقیت انجام شد");
            setUpdater(!Updater);
          }
        }
      });
    }
  }

  const Update = (info) => {
    if (!isString(info.profile_pic_file_path)) {
      let form = new FormData();
      form.append("file", info.profile_pic_file_path);
      files(form)
        .then((data) => {
          setSelectedUserInformation({
            ...SelectedUserInformation,
            ["profile_pic_file_path"]: data.result.id,
          });
          form.delete("file");
          form.append(
            "keyvalues",
            `mobile,${info.mobile}@@type,${info.type}@@fname,${info.fname}@@lname,${info.lname}@@codemeli,${info.codemeli}@@address,${info.address}@@mtm,${info.mtm}
          @@profile_pic_file_id,${data.result.id}
        ,@@bdday,${info.bdday}@@bdmonth,${info.bdmonth}@@bdyear,${info.bdyear}@@bdtm,${info.bdtm}
        `
          );
          form.append("conditions", `id/=/${info.id}`);
          Update_Users(form)
            .then((data) => {
              if (data.status == 1) {
                setUpdater(!Updater);
                showSwalSuccess("ویرایش مشخصات کاربر با موفقیت انجام شد");
              } else {
                Swal.fire(
                  "مشکلی در ویرایش مشخصات کاربر پیش آمده است",
                  "",
                  "warning"
                );
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      let form = new FormData();
      form.append(
        "keyvalues",
        `mobile,${info.mobile}@@type,${info.type}@@fname,${info.fname}@@lname,${info.lname}@@codemeli,${info.codemeli}@@address,${info.address}@@mtm,${info.mtm}
        ,@@bdday,${info.bdday}@@bdmonth,${info.bdmonth}@@bdyear,${info.bdyear}@@bdtm,${info.bdtm}
        `
      );
      form.append("conditions", `id/=/${info.id}`);
      Update_Users(form)
        .then((data) => {
          if (data.status == 1) {
            setUpdater(!Updater);
            showSwalSuccess("ویرایش مشخصات کاربر با موفقیت انجام شد");
          } else {
            Swal.fire(
              "مشکلی در ویرایش مشخصات کاربر پیش آمده است",
              "",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const FilterUsers = (users) => {
    let Customers = [...users];
    let Personel = [...users];
    setFilteredCustomers(Customers.filter((item) => item.type == 2));
    setFilteredPersonel(Personel.filter((item) => item.type == 1));
  };

  const User_Access = (id) => {
    let form = new FormData();
    form.append("conditions", `uid/=/${id}`);
    Find_UserRoll(form)
      .then((data) => {
        let array = [];
        data.map((item) => array.push(item.value));
        setUserAccess(array);
        setFirstAccess(array);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTages = () => {
    Find_Tag()
      .then((data) => {
        let array = [];
        data.forEach((element) => {
          array.push({ value: `${element.id}`, label: `${element.text}` });
        });
        settags(array);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getPServise = () => {
    let form = new FormData();
    form.append("conditions", "main_type/=/4");
    Find_ProductServices(form)
      .then((data) => {
        let array = [];
        data.forEach((element) => {
          array.push({ value: `${element.id}`, label: `${element.title}` });
        });
        setPServices(array);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getCustomer = () => {
    Find_Customers()
      .then((data) => {
        let array = [];
        data.forEach((element) => {
          array.push({
            value: `${element.id}`,
            label: `${element.company_name}`,
          });
        });
        setCustomers(array);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getUsers = (type, page = 0) => {
    let form = new FormData();
    form.append("user_type", type);
    form.append("page", page + 1);
    form.append("count", "10");
    fullusers(form)
      .then((data) => {
        if (type == 1) {
          setCountPersonal(parseInt(data.userCount));
          setFilteredPersonel(data.data);
        } else {
          setCountCustomers(parseInt(data.userCount));
          setFilteredCustomers(data.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getAccessLevel = () => {
    access_level()
      .then((data) => {
        setAccess(Object.entries(data.access_level));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getTages();
    getUsers(1, pagination);
    getUsers(2, pagination2);
    getPServise();
    getCustomer();
    getAccessLevel();
  }, [Updater]);

  const Pages = (page, type) => {
    getUsers(type, page);
  };

  const SendMessage = (AppendObj, people, setSendMg) => {
    if (people.length == 1) {
      if (people[0][1] == "" && AppendObj.needemail == 1) {
        showSwalError("\n کاربر مورد نظر ایمیلی ندارد");
      } else {
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        let form = new FormData();
        form.append("sender_id", `${auth.userInfo.id}`);
        form.append(
          "type",
          AppendObj.needsms ? 1 : AppendObj.needemail ? 2 : 0
        );
        form.append("reciver_id", `${people[0][0]}`);
        form.append("text", `${AppendObj.msgtxt}`);
        form.append("mtm", `${timestamp}`);
        form.append("automate", 0);
        // form.append("needsms", `${AppendObj.needsms ? 1 : 0}`);
        // form.append("needemail ", `${AppendObj.needemail ? 1 : 0}`);
        Insert_Message(form)
          .then((data) => {
            if (data.status) {
              showSwalSuccess("پیام ارسال شد");
              setSendMg({
                ...AppendObj,
                ["msgtxt"]: "",
                ["needsms"]: false,
                ["needemail"]: false,
              });
            } else {
              showSwalError("\n مشکلی در ارسال پیام پیش آمده است ");
              return;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      let key = 0;
      people.some((item) => {
        if (item[1] == "" && AppendObj.needemail && key == 0) {
          key = 1;
          showSwalError("\n تعدادی از کاربران مورد نظر ایمیل ندارند");
          return false;
        }
      });
      if (key == 0) {
        let wrong = true;
        var Break = true;
        people.some((item) => {
          const currentDate = new Date();
          const timestamp = currentDate.getTime();
          let form = new FormData();
          form.append("sender_id", `${auth.userInfo.id}`);
          form.append(
            "type",
            AppendObj.needsms ? 1 : AppendObj.needemail ? 2 : 0
          );
          form.append("reciver_id", `${item[0]}`);
          form.append("text", `${AppendObj.msgtxt}`);
          form.append("automate", 0);
          form.append("mtm", `${timestamp}`);
          // form.append("needsms", `${AppendObj.needsms ? 1 : 0}`);
          // form.append("needemail", `${AppendObj.needemail ? 1 : 0}`);
          Insert_Message(form)
            .then((data) => {
              if (!data.status && wrong) {
                wrong = false;
                showSwalError("\n  مشکلی در ارسال چند پیام پیش آمده است");
              }
            })
            .catch(({ errors }) => {
              console.log(errors);
            });
          if (wrong) {
            showSwalSuccess("پیام ارسال شد");
            setSendMg({
              ...AppendObj,
              ["msgtxt"]: "",
              ["needsms"]: false,
              ["needemail"]: false,
            });
          }
        });
      }
    }
  };

  const FilterSend = (conditions, page) => {
    if (dates.length == 1) {
      showSwalError("\nلطفا دو روز را انتخاب کنید");
    } else {
      let filters = new FormData();
      let flag = 0;
      Object.keys(filter).map((item) => {
        if (filter[item] != "") {
          filters.append(`${item}`, filter[item]);
          flag = 1;
        }
      });

      if (flag == 1) {
        filters.append(`user_type`, conditions);
        filters.append("page", `${page}`);
        filters.append("count", "10");
        fullusers(filters)
          .then((data) => {
            flag = 0;
            if (conditions == 1) {
              setCountPersonal(data.userCount);
              setFilteredPersonel(data.data);
            } else {
              setCountCustomers(data.userCount);
              setFilteredCustomers(data.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Pages(1, 1);
        Pages(1, 2);
      }
    }
  };

  return (
    <div className="user-management-main-container">
      {loading ? <Loader /> : ""}

      <Helmet>
        <title> CRM | مدیریت کاربران</title>
      </Helmet>

      <Modals
        chosenPeople={Tab == 1 ? chosenPersonel : chosenCustomers}
        Tab={Tab}
        Update={Update}
        changeStatus={changeStatus}
        SelectedUserInformation={SelectedUserInformation}
        EditUser={setSelectedUserInformation}
        Access={Access}
        Citys={Citys}
        UserAccess={UserAccess}
        setUserAccess={setUserAccess}
        Labels={tags}
        FirstAccess={FirstAccess}
        setUpdater={setUpdater}
        Updater={Updater}
        SendMessage={SendMessage}
      ></Modals>

      <div className="  bg-light pt-3 pb-5">
        <div className="d-flex">
          <button
            className="btn btn-success m-4 d-flex"
            style={{ height: "fit-content" }}
            id=""
            data-bs-toggle="modal"
            data-bs-target="#FilterModal"
          >
            <FaFilter className="m-1" />
            <span>فیلتر</span>
          </button>
          <button
            className="btn btn-danger m-4 d-flex"
            style={{ height: "fit-content" }}
            id=""
            onClick={() => {
              setFilterKey(false);
              setFilter({
                ...filter,
                ["user_type"]: "",
                ["fname"]: "",
                ["lname"]: "",
                ["mobile"]: "",
                ["codemeli"]: "",
                ["frommtm"]: "",
                ["tomtm"]: "",
                ["main_status"]: "",
                ["user_tags_ids"]: "",
              });
              setFilterTag([]);
              setUpdater(!Updater);
              setDates([]);
              setpagination(0);
              setpagination2(0);
            }}
          >
            <FaTrashAlt className="mx-1" />
            <span>حذف فیلتر</span>
          </button>
        </div>

        <div className="mx-5">
          <Filter
            filterTag={filterTag}
            setFilterTag={setFilterTag}
            updateFilteredUsers={FilterUsers}
            Labels={tags}
            Pages={Pages}
            setFilterKey={setFilterKey}
            setCountCustomers={setCountCustomers}
            setCountPersonal={setCountPersonal}
            FilterSend={FilterSend}
            setDates={setDates}
            setFilter={setFilter}
            dates={dates}
            filter={filter}
          ></Filter>

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            {userInfo.userRoll.includes(25) && (
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#personnel"
                  type="button"
                  role="tab"
                  aria-controls="personnel"
                  aria-selected="true"
                  onClick={() => setTab(1)}
                >
                  پرسنل
                </button>
              </li>
            )}
            {userInfo.userRoll.includes(26) && (
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="customers-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#customers"
                  type="button"
                  role="tab"
                  aria-controls="customers"
                  aria-selected="false"
                  onClick={() => setTab(0)}
                >
                  مشتریان
                </button>
              </li>
            )}
          </ul>

          <div className="tab-content " id="myTabContent">
            {userInfo.userRoll.includes(25) && (
              <PersonnelTab
                PServices={PServices}
                Customers={Customers}
                pagination={pagination}
                setpagination={setpagination}
                deleteUser={deleteUser}
                changeStatus={changeStatus}
                filteredUsers={filteredPersonel}
                setSelectedUserInformation={setSelectedUserInformation}
                setChosenPeople={setChosenPersonel}
                chosenPeople={chosenPersonel}
                Labels={tags}
                Pages={Pages}
                User_Access={User_Access}
                Updater={Updater}
                CountPersonal={countPersonal}
                FilterKey={FilterKey}
                FilterSend={FilterSend}
                setId={setId}
                setUpdaterModal={setUpdaterModal}
                UpdaterModal={UpdaterModal}
              ></PersonnelTab>
            )}

            {userInfo.userRoll.includes(26) && (
              <CustomerTab
                PServices={PServices}
                Customers={Customers}
                pagination={pagination2}
                setpagination={setpagination2}
                CountCustomers={countCustomers}
                deleteUser={deleteUser}
                changeStatus={changeStatus}
                filteredUsers={filteredCustomers}
                setSelectedUserInformation={setSelectedUserInformation}
                setChosenPeople={setChosenCustomers}
                chosenPeople={chosenCustomers}
                Labels={tags}
                Pages={Pages}
                User_Access={User_Access}
                Updater={Updater}
                FilterKey={FilterKey}
                FilterSend={FilterSend}
                setId={setId}
                setUpdaterModal={setUpdaterModal}
                UpdaterModal={UpdaterModal}
              ></CustomerTab>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
